import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import { useDialogStyles } from './styles';
import { useMoveTimeChangeHandlers } from './hooks';
import { MOVE_TIME_STEP_INDICES } from './constants';
import StepSidebar from './StepSidebar';
import SelectMoveTimeStep from './SelectMoveTimeStep';
import DestinationMoveTimeStep from './DestinationMoveTimeStep';
import ProgressMoveTimeStep from './ProgressMoveTimeStep';
import ResultMoveTimeStep from './ResultMoveTimeStep';

const MoveTimeDialogContent = ({
  activeStep,
  moveTimeData,
  setMoveTimeData,
  timeEntrySummary,
  batchState,
  batchResults,
  onBatchComplete,
  initialProject,
  initialTask
}) => {
  const dialogClasses = useDialogStyles();
  const {
    handleSourceProjectChange,
    handleSourceTaskChange,
    handleDestinationProjectChange,
    handleDestinationTaskChange,
    handleBillingStatusChange,
    handleCriteriaChange
  } = useMoveTimeChangeHandlers({
    setMoveTimeData
  });

  return (
    <>
      <StepSidebar activeStep={activeStep} />
      <Box className={dialogClasses.mainContent}>
        {activeStep === MOVE_TIME_STEP_INDICES.SELECTION && (
          <SelectMoveTimeStep
            moveTimeData={moveTimeData}
            setMoveTimeData={setMoveTimeData}
            onProjectChange={handleSourceProjectChange}
            onTaskChange={handleSourceTaskChange}
            onCriteriaChange={handleCriteriaChange}
            timeEntrySummary={timeEntrySummary}
            initialProject={initialProject}
            initialTask={initialTask}
          />
        )}
        {activeStep === MOVE_TIME_STEP_INDICES.DESTINATION && (
          <DestinationMoveTimeStep
            moveTimeData={moveTimeData}
            onDestinationProjectChange={handleDestinationProjectChange}
            onDestinationTaskChange={handleDestinationTaskChange}
            onBillingStatusChange={handleBillingStatusChange}
            timeEntrySummary={timeEntrySummary}
          />
        )}
        {activeStep === MOVE_TIME_STEP_INDICES.PROGRESS && (
          <ProgressMoveTimeStep
            batchId={batchState.batchId}
            timeEntrySummary={timeEntrySummary}
            moveTimeData={moveTimeData}
            onBatchComplete={onBatchComplete}
          />
        )}
        {activeStep === MOVE_TIME_STEP_INDICES.RESULT && (
          <ResultMoveTimeStep
            timeEntrySummary={timeEntrySummary}
            moveTimeData={moveTimeData}
            batchResults={batchResults}
          />
        )}
      </Box>
    </>
  );
};

MoveTimeDialogContent.propTypes = {
  activeStep: PropTypes.number.isRequired,
  moveTimeData: PropTypes.object.isRequired,
  setMoveTimeData: PropTypes.func.isRequired,
  timeEntrySummary: PropTypes.object.isRequired,
  batchState: PropTypes.object.isRequired,
  batchResults: PropTypes.object,
  onBatchComplete: PropTypes.func.isRequired,
  initialProject: PropTypes.object,
  initialTask: PropTypes.object
};

export default MoveTimeDialogContent;
